export const hasAtmostTwoDecimalPlaces = (value) =>
  /^\d*(\.\d{0,2})?$/.test(value);

export const validateOfferName = (offerName) => {
  let errorOffer;
  if (!offerName) {
    errorOffer = "Please enter a name for the offer";
  } else if (
    !/^([a-zA-Z0-9]+\s)*[a-zA-Z0-9]+$/.test(offerName) &&
    (offerName.trim().length === 0 || !offerName.endsWith(" "))
  ) {
    errorOffer = "Invalid Name";
  }
  return errorOffer;
};

export const validateDiscountPrice = (discountPrice, originalPrice) => {
  let errorDiscount;
  if (!discountPrice) {
    errorDiscount = "Required";
  } else if (!hasAtmostTwoDecimalPlaces(discountPrice)) {
    errorDiscount = "Please add price upto 2 decimals only.";
  } else if (
    originalPrice &&
    parseFloat(discountPrice) > parseFloat(originalPrice)
  ) {
    errorDiscount = "Price cannot be greater than the original price";
  }
  return errorDiscount;
};

export const validatePercentage = (value) => {
  if (!value) return "Required";
  const num = parseFloat(value);
  if (isNaN(num) || num <= 0 || num > 100) {
    return "Enter a value between 1 and 100";
  }
};

export const validateEndDate = (end_date, values) => {
  let errorEndDate;
  if (!end_date) {
    errorEndDate = "Required";
  } else if (new Date(end_date) < new Date(values.start_date)) {
    errorEndDate = "End date should be greater than start date";
  }
  return errorEndDate;
};

export const validateDiscountPriceInternational = (
  discountPriceInternational,
  originalPrice
) => {
  let errorDiscountInternational;
  if (!discountPriceInternational) {
    errorDiscountInternational = "Required";
  } else if (!hasAtmostTwoDecimalPlaces(discountPriceInternational)) {
    errorDiscountInternational = "Please add price upto 2 decimals only.";
  } else if (
    originalPrice &&
    parseFloat(discountPriceInternational) > parseFloat(originalPrice)
  ) {
    errorDiscountInternational =
      "Price cannot be greater than the original price";
  }
  return errorDiscountInternational;
};
